import { Component, OnInit, Inject, PLATFORM_ID, makeStateKey, TransferState, Optional } from '@angular/core';
import { isPlatformServer, isPlatformBrowser } from '@angular/common';
import { DISABLE_ANDROID_DOWNLOAD, DISABLE_IOS_DOWNLOAD } from 'src/app/tokens/ssr-flags.token';

const DISABLE_IOS_KEY = makeStateKey<boolean>('disableiOSDownload');
const DISABLE_ANDROID_KEY = makeStateKey<boolean>('disableAndroidDownload');

@Component({
  selector: 'app-dowload-app-slide',
  templateUrl: './dowload-app-slide.component.html',
  styleUrls: ['./dowload-app-slide.component.scss'],
})
export class DowloadAppSlideComponent implements OnInit {

  disableiOS = false;
  disableAndroid = false;
  isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private transferState: TransferState,
    @Optional() @Inject(DISABLE_IOS_DOWNLOAD) private disableiOSDownload: boolean,
    @Optional() @Inject(DISABLE_ANDROID_DOWNLOAD) private disableAndroidDownload: boolean
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);

    if (isPlatformServer(this.platformId)) {
      this.transferState.set(DISABLE_IOS_KEY, this.disableiOSDownload);
      this.transferState.set(DISABLE_ANDROID_KEY, this.disableAndroidDownload);
    } else {
      this.disableiOS = this.transferState.get(DISABLE_IOS_KEY, false);
      this.disableAndroid = this.transferState.get(DISABLE_ANDROID_KEY, false);
       if (sessionStorage.getItem('disableiOS') === null && sessionStorage.getItem('disableAndroid') === null) {
        sessionStorage.setItem('disableiOS', JSON.stringify(this.disableiOS));
        sessionStorage.setItem('disableAndroid', JSON.stringify(this.disableAndroid));
      }
    }
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      const savedIOS = sessionStorage.getItem('disableiOS');
      const savedAndroid = sessionStorage.getItem('disableAndroid');
      if (savedIOS !== null && savedAndroid !== null) {
        this.disableiOS = JSON.parse(savedIOS);
        this.disableAndroid = JSON.parse(savedAndroid);
      } 
    }
  }
}
